export default class ChartAction {
  id: string | null;

  isSelected: boolean;

  label: string | null;

  rank: number;

  enabled: boolean;

  constructor(id?: string, isSelected = false, label?: string, rank = 0, enabled = true) {
    this.id = id;
    this.isSelected = isSelected;
    this.label = label;
    this.rank = rank;
    this.enabled = enabled;
  }
}
